import DefaultLayout from './default';
import ToolsLayout from './tools';
import LandLayout from './land';
import SubscriptionsLayout from './subscriptions';
import AffiliateLayout from './affiliate';
import PromoLayout from './PromoLayout';
import ForbiddenLayout from './ForbiddenLayout';
import OfferLayout from './offer';
import LightLayout from './light';

export {
    DefaultLayout,
    ToolsLayout,
    LandLayout,
    SubscriptionsLayout,
    AffiliateLayout,
    PromoLayout,
    ForbiddenLayout,
    OfferLayout,
    LightLayout,
};
